import React from "react";
const Flag = (props) => {
  return (
    <svg width="24px" height="24px" viewBox="5 2 20 22" {...props}>
      <path d="M7,8.5 L7,29 L8,29 L8,14 L23,14 L23,3 L7,3 L7,8.5 L7,8.5 Z" />
    </svg>
  );
};
export default Flag;
